import React from 'react';

import InfoCard from './InfoCard';
import { Markdown } from '../elements';

const WhyChooseUs = ({ heading, whyChooseUs = [] }) => {
  return (
    <section className="section">
      <div className="container">
        {heading && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown className="pb-2 has-text-grey-dark">{heading}</Markdown>
            </div>
          </div>
        )}

        <div className="columns is-multiline">
          {whyChooseUs.map((item) => {
            return (
              <div className="column is-4" key={item._key}>
                <InfoCard data={item} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
